/** 書いて AC の判定文言（judge.md §3、copy-guidelines.md §4） */
import type { CaseResult, JudgeResult } from '../../lib/judge';
import type { GradeResult } from '../types';

/** 最初に AC でなかったケース */
export function firstFailure(judge: JudgeResult): CaseResult | undefined {
  return judge.cases.find((c) => c.verdict !== 'AC');
}

/** コンパイラ出力の最初の error 行の行番号（main.swift:3:5: error: …） */
export function compileErrorLine(output: string): number | null {
  const m = /^main\.swift:(\d+):\d+: error:/m.exec(output);
  return m ? Number(m[1]) : null;
}

export function caseLabel(cases: readonly { name?: string }[], i: number): string {
  const name = cases[i]?.name;
  return name ? `ケース ${i + 1}（${name}）` : `ケース ${i + 1}`;
}

export function writeAcResult(
  judge: JudgeResult,
  cases: readonly { name?: string; out: string }[],
): GradeResult {
  const n = judge.cases.length;
  if (judge.overall === 'AC') {
    return { verdict: 'AC', message: `全 ${n} ケースで出力が一致しました。` };
  }
  if (judge.overall === 'CE') {
    const line = compileErrorLine(judge.compileOutput);
    return {
      verdict: 'CE',
      message: line
        ? `コンパイルできませんでした（${line} 行目）。`
        : 'コンパイルできませんでした。',
    };
  }
  // overall はもっとも重い判定。その判定が最初に出たケースを示す
  const c = judge.cases.find((x) => x.verdict === judge.overall) ?? firstFailure(judge);
  if (!c) return { verdict: judge.overall };
  const label = caseLabel(cases, c.index);
  const common = {
    caseIndex: c.index,
    ...(c.durationMs !== null ? { durationMs: c.durationMs } : {}),
  };
  const tally = `${n} ケース中 ${judge.acCount} ケースで一致しました。`;
  switch (judge.overall) {
    case 'TLE':
      return {
        verdict: 'TLE',
        ...common,
        message: `${label} が 3 秒以内に終わりませんでした。${tally}`,
      };
    case 'RE':
      return {
        verdict: 'RE',
        ...common,
        stderr: c.stderr,
        message:
          c.detail === 'output-limit'
            ? `${label} の出力が上限を超えたため止めました。${tally}`
            : `${label} の実行中に止まりました。${tally}`,
      };
    default:
      return {
        verdict: 'WA',
        ...common,
        expected: cases[c.index]?.out ?? '',
        actual: c.stdout,
        message: `${label} で出力が一致しませんでした。期待する出力と並べて表示します。`,
      };
  }
}
